import React from "react";
import { UsersProvider } from "../Context/UsersContext";
import UsersContent from "./Users/UsersContent";

const Users = () => {
  return (
    <UsersProvider>
      <UsersContent />
    </UsersProvider>
  );
};

export default Users;